import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

type Props = { isSorting: boolean };

export const VoucherTableHeader = ({ isSorting }: Props) => {
	return (
		<TableHeader>
			<TableRow>
				{isSorting && <TableHead></TableHead>}
				<TableHead></TableHead>
				<TableHead></TableHead>
				<TableHead>名前</TableHead>
				<TableHead>残在庫</TableHead>
				<TableHead>販売期間</TableHead>
				<TableHead>販売価格</TableHead>
				<TableHead>適用価格</TableHead>
				<TableHead>操作</TableHead>
			</TableRow>
		</TableHeader>
	);
};

VoucherTableHeader.displayName = "VoucherTableHeader";
